import React, { useRef, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Footer from "../components/Footer";
import "./style.css";
import ConsultationForm from "../components/ConsultationForm";
import CallIcon from "../assets/Icons/call-icon.svg"; 

const Frame = (props) => {
  return (
    <div className="about-us-frame" >
      <div className="div-2">
        <div className="text-wrapper-2">{props.header1}</div>

        <div className="text-wrapper-3">{props.header2}</div>
      </div>

      <p className="about-us-p">{props.desc}</p>
    </div>
  );
};

const Group = () => {
  return (
    <div
      className="flex flex-col items-center  
             md:flex-row md:items-center md:justify-between md:gap-6 w-full mt-10 "
    >
      <div className="flex flex-col items-center">
        <div className="text-3xl font-semibold text-[#051d62]">99.5%</div>

        <div className="opacity-80 text-[#263238]">Visa approved</div>
      </div>

      <img
        className="h-8"
        alt="Vector"
        src="https://c.animaapp.com/HwA6Ml4A/img/vector-24.svg"
      />
      <div className="flex flex-col items-center">
        <div className="text-3xl font-semibold text-[#051d62]">10000+</div>

        <div className="opacity-80 text-[#263238]">Students Guided</div>
      </div>
      <img
        className="h-8"
        alt="Vector"
        src="https://c.animaapp.com/HwA6Ml4A/img/vector-25.svg"
      />
      <div className="flex flex-col items-center">
        <div className="text-3xl font-semibold text-[#051d62]">100%</div>

        <div className="opacity-80 text-[#263238]">Student satisfaction</div>
      </div>
      <img
        className="h-8"
        alt="Vector"
        src="https://c.animaapp.com/HwA6Ml4A/img/vector-26.svg"
      />
      <div className="flex flex-col items-center">
        <div className="text-3xl font-semibold text-[#051d62]">2021</div>

        <div className="opacity-80 text-[#263238]">Established</div>
      </div>
    </div>
  );
};

const Container = () => {
  return (
    <div className="container">
      <p className="text-wrapper-12"> Start your Education Journey Today </p>

      <p className="from-initial">
        Ready to take the next step? Book a free consultation with our education
        experts and let us
        <br />
        help you achieve your Global study goals.
      </p>
    </div>
  );
};

const GetExpertSupport = () => {
  return (
    <div className="get-expert-support">
      <p className="span expert-p">
        Get expert support to access world-class learning opportunities globally.
      </p>
    </div>
  );
};

const Background = (props) => {
  return (
    <div className="background">
      <div className="heading">
        <p className="text-wrapper-9">
          Ready to Start Your Education Journey?
        </p>
      </div>

      <div className="book-a-free-wrapper">
        <p className="book-a-free">
          Book a free consultation with our education experts and take the first
          step
          <br />
          towards your dream university.
        </p>
      </div>

      <button onClick={props.onClickConsultation} className="button">
        <div className="text-wrapper-10">Book Free Consultation</div>

        <img
          className="SVG"
          alt="Svg"
          src="https://c.animaapp.com/XwKqq1VA/img/svg.svg"
        />
      </button>
    </div>
  );
};

export default function AboutUs() {
  const formSectionRef = useRef(null);
  const handleFocusSection = () => {
    formSectionRef.current.scrollIntoView({ behavior: "smooth" });
    formSectionRef.current.focus();
  };
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <div className="about-us">
      <div className="">
        {/* MOBILE HERO + TEXT */}
        <section className=" pt-2 pb-0 text-center md:hidden">
          <h2 className="text-[28px] font-semibold text-[#051d62] leading-tight">
            We are here to
            <br />
            <span className="text-blue-700">help you!</span>
          </h2>

          <p className="p-2 mt-4 text-gray-600 text-[16px] leading-relaxed">
            We have been assisting students for more than a decade and take
            pride in helping anyone who has a dream to study in the abroad.
          </p>

          <img
            className="w-full mt-4 rounded-lg"
            src={"https://c.animaapp.com/XwKqq1VA/img/rectangle-6062.png"}
            alt="Students"
          />
        </section>

        {/* DESKTOP HERO + TEXT */}
        <div className="hidden md:block">
          <div className="services-rectangle">
            <div className="frame">
              <div className="service-div-2">
                <div className="service-text-wrapper-2">We are here to</div>

                <div className="service-text-wrapper-3">help you!</div>
              </div>

              <p className="p">
                We have been assisting students for more than a decade and take
                pride in helping anyone who has a dream to study in the abroad.
              </p>
            </div>

            <img
              className="services-rectangle-2"
              alt="Rectangle"
              src={"https://c.animaapp.com/XwKqq1VA/img/rectangle-6062.png"}
            />
          </div>
        </div>
      </div>
      <GetExpertSupport />
      <div className="about-us-background">
        <Group />

        <div
          className="about-text-image-section"
          style={{ paddingTop: "50px", }}
        >
          <Frame
            header1={""}
            header2={
              "Why we would be your best fit for the higher education plans?"
            }
            desc={`We have been in business for a significant time and understand the ever-shifting dynamics of the higher education market. Together with the extensive knowledge and insight through our existing collaborative approach, we would be helping you to put the best foot forward! 
              Global StudyIn’s English training programs provide one-on-one guidance to help you improve your skills and achieve the score needed for admission to your chosen university.`}
          />

          <img
            className="language-rectangle-2"
            alt="Rectangle"
            src="https://c.animaapp.com/XwKqq1VA/img/our-story-img@2x.png"
          />
        </div>

        <Background onClickConsultation={handleFocusSection} />

        <Container />

        <div ref={formSectionRef} className="card-form frame-4">
          <section id={"features-form-load-about-us"} style={{ width: "100%" }}>
            <ConsultationForm />
          </section>
          <div className="container-21">
            <div className="background-shadow-2">
              <div className="container-22">
                <img
                  className="overlay"
                  alt="Overlay"
                  src="https://c.animaapp.com/XwKqq1VA/img/overlay.svg"
                />

                <div className="container-23">
                  <div className="heading-3">
                    <div className="text-wrapper-25">Email Us</div>
                  </div>

                  <div className="container-24">
                    <div className="text-wrapper-26"><a href="mailto:info@globalstudyin.com" className="text-blue-600 underline hover:text-blue-800 transition-colors duration-200">
                      info@globalstudyin.com
                    </a></div>
                  </div>

                  <div className="container-26">
                    <p className="text-wrapper-27">
                      We&#39;ll respond within 24 hours
                    </p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="background-shadow-2 custom-h-100">
              <div className="container-22">
                <img
                  className="overlay"
                  alt="Overlay"
                  src={CallIcon}
                />

                <div className="container-23">
                  <div className="heading-3">
                    <div className="text-wrapper-25">Contact Us</div>
                  </div>
                  <div className="container-24">
                    <div className="text-wrapper-26">+44 20 7277 6666</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Office Hours card removed per request */}

            <div className="background-shadow-4">
              <div className="container-29">
                <div className="div-3">
                  <div className="text-wrapper-29">Why Students Choose Us</div>
                </div>

                <div className="container-30">
                  <div className="container-31">
                    <img
                      className="SVG-4"
                      alt="Svg"
                      src="https://c.animaapp.com/XwKqq1VA/img/svg-7.svg"
                    />

                    <div className="container-32">
                      <div className="text-wrapper-30">
                        10000+ Students Successfully Placed
                      </div>
                    </div>
                  </div>

                  <div className="container-31">
                    <img
                      className="SVG-4"
                      alt="Svg"
                      src="https://c.animaapp.com/XwKqq1VA/img/svg-8.svg"
                    />

                    <div className="container-32">
                      <div className="text-wrapper-30">
                        200+ Partner Universities
                      </div>
                    </div>
                  </div>

                  <div className="container-31">
                    <img
                      className="SVG-4"
                      alt="Svg"
                      src="https://c.animaapp.com/XwKqq1VA/img/svg-9.svg"
                    />

                    <div className="container-32">
                      <div className="text-wrapper-30">
                        25+ Years of Experience
                      </div>
                    </div>
                  </div>

                  <div className="container-31">
                    <img
                      className="SVG-4"
                      alt="Svg"
                      src="https://c.animaapp.com/XwKqq1VA/img/svg-10.svg"
                    />

                    <div className="container-32">
                      <div className="text-wrapper-30">
                        24/7 Student Support
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="language-footer">
        <Footer />
      </div>
    </div>
  );
}
